import { render, staticRenderFns } from "./ServiceAccountSettings.vue?vue&type=template&id=778b6830"
import script from "./ServiceAccountSettings.vue?vue&type=script&lang=js"
export * from "./ServiceAccountSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports